// FacultySection.jsx (Main Component)
import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import automationexpert from "../img/aaaservices/Ceo.jpg";
import virtualrobotics from "../img/aaaservices/KIRANSIR.jpg";
import toolfixture from "../img/aaaservices/12_SARANYA.jpg";

export const facultyData = [
  {
    id: 1,
    name: "CCS CHANDRASHEKHAR REDDY",
    shortName: "CCS REDDY",
    designation: "Founder & Principal",
    image: automationexpert,
    expertise: "Automation Expert",
    description: "CCS Reddy is a renowned Automation Expert with over 15 years of experience in industrial automation, PLC programming, SCADA systems, and robotics integration. He has led numerous successful automation projects across manufacturing, automotive, and process industries. His expertise includes Industry 4.0 implementation, IoT solutions, and smart factory automation.",
    journey: "Started his career as a control engineer, worked with top MNCs, founded this institution to train next generation automation professionals. Certified in Siemens, Allen Bradley, and CODESYS platforms.",
    fullDetails: "🏆 Awarded 'Best Automation Engineer' 2020\n📚 Published 12 research papers\n🎤 Keynote speaker at 25+ international conferences\n🔧 Trained 5000+ students in automation",
    experience: "15+ Years",
    projects: "50+ Major Projects",
    students: "5000+ Trained",
    email: "ccs.reddy@institute.edu",
    phone: "+91 98765 43210",
    linkedin: "linkedin.com/in/ccsreddy",
    education: "M.Tech in Automation, IIT Delhi\nB.E. in Electrical Engineering",
    certifications: "Siemens Certified Engineer\nAllen Bradley Specialist\nCODESYS Advanced Professional"
  },
  {
    id: 2,
    name: "KIRAN",
    shortName: "KIRAN",
    designation: "Vice Principal",
    image: virtualrobotics,
    expertise: "Virtual Robotics Expert",
    description: "Kiran is a pioneer in Virtual Robotics and Simulation. With expertise in ROS, Gazebo, V-REP, and digital twin technologies, she specializes in creating virtual environments for robot testing and validation. Her work bridges the gap between simulation and real-world robotics applications.",
    journey: "PhD in Robotics from IIT, worked with leading robotics companies, developed virtual training modules for industrial robots. Expert in Python, C++, and robot operating systems.",
    fullDetails: "🤖 Created India's first virtual robotics lab\n📱 Developed 30+ robot simulation models\n🎓 Mentored 200+ robotics projects\n🌍 International collaborator with 5 universities",
    experience: "12+ Years",
    projects: "30+ Simulation Projects",
    students: "2000+ Mentored",
    email: "kiran@institute.edu",
    phone: "+91 98765 43211",
    linkedin: "linkedin.com/in/kiranrobotics",
    education: "PhD in Robotics, IIT Bombay\nM.Tech in AI & Robotics",
    certifications: "ROS Professional Certification\nGazebo Master Trainer\nDigital Twin Specialist"
  },
  {
    id: 3,
    name: "SRAYANAYA",
    shortName: "SRAYANAYA",
    designation: "Senior Faculty",
    image: toolfixture,
    expertise: "Tool & Fixture Expert",
    description: "Srayanaya is a highly skilled Tool & Fixture Design Expert with deep knowledge of jigs, fixtures, press tools, mould design, and GD&T. He has designed over 500+ tools for automotive and aerospace industries, optimizing production efficiency and quality.",
    journey: "Diploma in Tool Engineering, 12+ years industry experience, worked as Tool Room Manager at leading manufacturing firms. Expert in AutoCAD, NX, Catia, and SolidWorks.",
    fullDetails: "🔩 Designed tools saving ₹15Cr in production costs\n📐 Certified in Advanced GD&T\n🏭 Consulted for 50+ manufacturing units\n📖 Author of 'Tool Design Made Easy'",
    experience: "12+ Years",
    projects: "500+ Tools Designed",
    students: "3000+ Trained",
    email: "srayanaya@institute.edu",
    phone: "+91 98765 43212",
    linkedin: "linkedin.com/in/srayanaya",
    education: "B.E. in Mechanical Engineering\nDiploma in Tool Engineering (Gold Medalist)",
    certifications: "Advanced GD&T Professional\nNX CAD Specialist\nSolidWorks Expert"
  },
];

const FacultySection = () => {
  const navigate = useNavigate();

  const handleCardClick = (faculty) => {
    // Navigate to faculty details page with state
    navigate(`/faculty/${faculty.id}`, { state: { faculty } });
  };

  return (
    <Box
      sx={{
        py: 0,
        background: "#0000ff",
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="lg">
        {/* Heading */}
        <Box textAlign="center" mb={6}>
          <Typography
            sx={{
              fontSize: { xs: "30px", md: "35px" },
              fontWeight: 700,
            }}
          >
            <span style={{ color: "#fff" }}>Our Great </span>
            <span style={{ color: "#FFA500" }}>Faculties</span>
          </Typography>
          <Typography
            sx={{
              color: "#fff",
              mt: 2,
              fontSize: "18px",
              opacity: 0.9,
            }}
          >
            Click on any faculty card to view complete profile & expertise
          </Typography>
        </Box>

        {/* Center Cards */}
        <Grid container spacing={4} justifyContent="center">
          {facultyData.map((faculty) => (
            <Grid item xs={12} sm={6} md={4} key={faculty.id}>
              <Card
                onClick={() => handleCardClick(faculty)}
                sx={{
                  textAlign: "center",
                  borderRadius: "20px",
                  overflow: "hidden",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: "0 15px 35px rgba(0,0,0,0.3)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={faculty.image}
                  alt={faculty.name}
                  sx={{
                    width: "100%",
                    height: 420,
                    objectFit: "cover",
                  }}
                />

                <CardContent sx={{ bgcolor: "#fff" }}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "22px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {faculty.shortName}
                  </Typography>

                  <Typography
                    sx={{
                      color: "#ff6b35",
                      mt: 1,
                      fontSize: "16px",
                      fontWeight: 500,
                    }}
                  >
                    {faculty.designation}
                  </Typography>

                  <Typography
                    sx={{
                      color: "#0000f9",
                      mt: 1.5,
                      fontSize: "14px",
                      fontWeight: 600,
                      bgcolor: "#f0f0ff",
                      display: "inline-block",
                      px: 2,
                      py: 0.5,
                      borderRadius: "20px",
                    }}
                  >
                    {faculty.expertise}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Footer Note */}
        <Box textAlign="center" mt={6}>
          {/* <Typography
            sx={{
              color: "#fff",
              fontSize: "14px",
              opacity: 0.7,
            }}
          >
            Tap on any faculty card to view complete journey and expertise details
          </Typography> */}
        </Box>
      </Container>
    </Box>
  );
};

export default FacultySection;